import helper from './helpers';
import 'jquery-ui-bundle';
import 'owl.carousel';
// enable push notifications
async function enablePushNotifications() {
	const applicationServerKey = process.env.CONFIG.VAPID.publicKey;
	if(window.navigator && navigator.serviceWorker) {
		try {
			const registerServiceWorker = await navigator.serviceWorker.register(dcuk.template_uri + '/src/sw.js');
			const hasAllowedNotifications = Notification.permission === 'granted';
			if (hasAllowedNotifications) {
				if (!helper.getCookie('web-push-notifications')) {
					await sendPushNotifications(registerServiceWorker, applicationServerKey);
				}
			} else {
				const permission = await Notification.requestPermission();
				if (permission === 'granted') {
					window.location.reload();
				}
			}
		} catch (error) {
			console.error(error);
		}
	}
}
// send push notification
async function sendPushNotifications(registerServiceWorker, applicationServerKey) {
	if (registerServiceWorker.active) {
		const subscription = await registerServiceWorker.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: helper.urlBase64ToUint8Array(applicationServerKey)
		});
		fetch(dcuk.api_url + "/web-push-notifications", {
			method: "POST",
			body: JSON.stringify(subscription),
			headers: {
				"Content-Type": "application/json"
			}
		}).then(response => {
			if (response.ok) {
				helper.setCookie('web-push-notifications', true, 1);
			}
		}).catch(error => {
			console.error("Fetch error:", error);
		});
	}
}
// lazy load bg images
function lazyload_bg_images() {
	const lazyBgElements = document.querySelectorAll(".lazy-bg");
	lazyBgElements.forEach(element => {
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					const backgroundImage = entry.target.getAttribute("data-background-image");
					entry.target.style.backgroundImage = `url(${backgroundImage})`;
					observer.unobserve(entry.target);
				}
			});
		});
		observer.observe(element);
	});
}
function lazyload() {
	let images = $('[data-src]');
	images.each(function() {
		if ($(this).attr('src') || $(this).data('lazy') == false) {
			return; // SKIP if already displayed
		}
		// Compare the position of the image and scroll
		let bounding = this.getBoundingClientRect();
		let isOnView = bounding.top >= 0 &&
		bounding.left >= 0 &&
		bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		bounding.right <= (window.innerWidth || document.documentElement.clientWidth);

		if (isOnView) {
			$(this).attr('src', $(this).data('src'));
			if ($(this).attr('data-srcset')) {
				$(this).attr('srcset', $(this).data('srcset'));
			}
		}
	});
}
// reposition owl nav buttons
function repositionOwlNav() {
	var owl = $('.owl-carousel.owl-loaded');
	var height = owl.parent('.slider').outerHeight() - (owl.find('.owl-nav button').outerHeight() / 2);
	owl.find('.owl-nav button').css("top", height / 2);
}
// init owl slider
function initOwlSlider() {
	var owls = $('.slider .owl-carousel');
	owls.each(function(index, element) {
		var owl = $(element);
		owl.owlCarousel({
			loop: true,
			nav: true,
			dots: owl.data('dots') || false,
			autoHeight: true,
			navText: [
				"<span class='fa fa-chevron-left'></span>",
				"<span class='fa fa-chevron-right'></span>"
			],
			responsive: {
				0: {
					items: 1
				},
				480: {
					items: 2
				},
				800: {
					items: 3
				},
				1020: {
					items: parseInt(owl.data('desktop-items')) || 4
				}
			}
		});
		setTimeout(function() {
			repositionOwlNav();
		}, 1000);
	});
}
function receiveIframeMessage(event) {
	//console.log(event);
	if(event.origin === 'https://form.jotform.com' && event.data && event.data.startsWith('setHeight:')) {
		// extract the height value from the message
		var parts = event.data.split(':');
		if(parts.length === 3) {
			var height = parseInt(parts[1]),
				iframe = document.getElementById('jotform-iframe-' + parts[2]);
			if(iframe) {
				iframe.style.height = (height += 1) + 'px';
			}
		}
	}
}
// add an event listener to handle messages
window.addEventListener('message', receiveIframeMessage, false);

// google ads
function autoplace_google_ads() {
	var single_post = $('body').hasClass('single-post'),
		single_news = $('body').hasClass('single-news');
	if(single_post || single_news) {
		var adCode = '<div id="div-gpt-ad-1547501206394-0" class="ad ad-300x250"><script type="text/javascript">googletag.cmd.push(function() { googletag.display("div-gpt-ad-1547501206394-0"); });</script></div>',
			entryContent = $('.entry-content'),
			secondParagraph = entryContent.find('> p:eq(1)');
		
		if(entryContent.find('#content').length) {
			secondParagraph = entryContent.find('#content > p:eq(1)');
		}

		if(secondParagraph.length) {
			secondParagraph.after(adCode);
		}
	}
}
function enableMobileNav() {
	$('.toggle-offcanvas, .site-overlay').on('click', function(e) {
		e.preventDefault();
		$('body').toggleClass('offcanvas-active');
	});
}
// subscribe popup
function enableSubscribePopup() {
	if(!helper.getCookie('subscribe-popup')) {
		var $html = '';
		$html += '<div id="subscribe-popup">';
			$html += '<div class="inner">';
				$html += '<p class="heading-4"><strong>Join our free newsletter</strong><span class="sep">|</span><span class="heading-5">Get the latest diabetes news and research</span></p>';
				$html += '<a href="/subscribe" class="ui-btn ui-btn-radius">Subscribe now</a>';
				$html += '<button type="button" class="close fa fa-close"></button>';
			$html += '</div>';
		$html += '</div>';
		$('#app').append($html);
	}
	$('#subscribe-popup .close').on('click', function() {
		helper.setCookie('subscribe-popup', true, 7);
		$('#subscribe-popup').remove();
	});
}
function addOffCanvasNav() {
	var nav = $('.navbar-primary .navbar-nav');
	$.fn.responsiveNav = function() {
		this.removeClass( 'menu-item-expanded' );
		if ( this.prev().hasClass( 'submenu-visible' ) ) {
			this.prev().removeClass( 'submenu-visible' ).slideUp( 350 );
			this.parent().removeClass( 'menu-item-expanded' );
		} else {
			this.parent().parent().find( '.menu-item .sub-menu' ).removeClass( 'submenu-visible' ).slideUp( 350 );
			this.parent().parent().find( '.menu-item-expanded' ).removeClass( 'menu-item-expanded' );
			this.prev().toggleClass( 'submenu-visible' ).hide().slideToggle( 350 );
			this.parent().toggleClass( 'menu-item-expanded' );
		}
	};
	$('.widget_nav_menu ul').append(nav.html());
	$( '.widget_nav_menu .menu-item-has-children' ).each( function( e ) {

		// Add a caret.
		$( this ).append( '<span></span>' );

		// Fire responsiveNav() when clicking a caret.
		$( '> span', this ).on( 'click', function( e ) {
			e.preventDefault();
			$( this ).responsiveNav();
		} );

		// Fire responsiveNav() when clicking a parent item with # href attribute.
		if ( '#' === $( '> a', this ).attr( 'href' ) ) {
			$( '> a', this ).on( 'click', function( e ) {
				e.preventDefault();
				$( this ).next().next().responsiveNav();
			} );
		}

	} );
}
jQuery(document).ready(function($) {
	var env = process.env.NODE_ENV;
	// enable mobile nav
	enableMobileNav()
	// enable push notifications
	enablePushNotifications();
	// lazy load bg images
	lazyload_bg_images();
	// lazy load
	lazyload();
	// autoplace google ads
	autoplace_google_ads();
	// init owl slider
	initOwlSlider();
	// off canvas nav
	addOffCanvasNav();
	// on scroll
	$(window).on('scroll', function(e) {
		lazyload();
		lazyload_bg_images();
	});
	// on resize
	$(window).on('resize', function() {
		setTimeout(function() {
			repositionOwlNav();
		}, 1000);
	});
	// enable subscribe popup
	//enableSubscribePopup();
	
	// old dcuk script >>>
	$('.bottomsur button').on('click', function() {
		var bmr;
		var age = document.getElementById("age").value;
		var gender = $("#gendermal").is(':checked');
		var height = document.getElementById("height").value;
		var weigth = document.getElementById("weigth").value;
		if (gender == true) {
			bmr = 88.362 + ( 13.397 * weigth ) + ( 4.799 * height ) - ( 5.677 * age );
		} else {
			bmr = 447.593 + ( 9.247 * weigth ) + ( 3.098 * height ) - ( 4.330 * age );
		}
		$('#lblResultre').html(bmr.toFixed(2) + " Kcal/Day");
	});

	// search
	$( '.toggle-search' ).on( 'click', function( event ) {

		event.preventDefault();

		var container = $( '#search' ),
			field = $( 'input[type="search"]', container );

		// Toggle class on search button.
		$( this ).toggleClass( 'toggle-close' );

		// Add class to container.
		container.toggleClass( 'search-open' );
		// Focus on / blur input field.
		if ( container.hasClass( 'search-open' ) ) {
			field.focus();
		} else {
			field.blur();
		}
	} );

	$( '#search, .search-close' ).on( 'click keyup', function( event ) {
		// Fire only when pressing Escape or clicking the .search-toggle button.
		if ( event.target.className === 'search-close' || event.keyCode === 27 ) {
			event.preventDefault();
			$( '.toggle-search' ).removeClass( 'toggle-close' );
			$( '#search' ).removeClass( 'search-open' );
			$( '#search input[type="search"]' ).blur();
		}
	} );
});